export default {
  wrapper: 'uploader-wrapper',
  input: 'upload-input',
};
